import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-in-rrsp.options";
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";
import {IncomeTaxPersonalSpouseInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-spouse-in-rrsp.options";
import {IncomeTaxPersonalChildInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-child-in-rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-form',
  templateUrl: './rrsp-personal-tax-form.component.html',
  styleUrls: ['./rrsp-personal-tax-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxFormComponent {

  @Input()
  incomeTaxPersonalForm: AdvancedFormGroup<IncomeTaxPersonalInRrspOptions>;

  @Input()
  form: AdvancedForm<RrspOptions>;

  isMarriedSubscription;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get mainPersonForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseInRrspOptions> {
    return this.incomeTaxPersonalForm.formElements.mainPerson as AdvancedFormGroup<IncomeTaxPersonalSpouseInRrspOptions>;
  }

  get spouseForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseInRrspOptions> {
    return this.incomeTaxPersonalForm.formElements.spouse as AdvancedFormGroup<IncomeTaxPersonalSpouseInRrspOptions>;
  }

  get childrenForm(): AdvancedFormArray<IncomeTaxPersonalChildInRrspOptions> {
    return this.incomeTaxPersonalForm.formElements.children as AdvancedFormArray<IncomeTaxPersonalChildInRrspOptions>;
  }

  refresh() {
  }
}
